import React from 'react';
import styled from 'styled-components';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from "../assets/images/logo-slogan.png";

const FooterContainer = styled.footer`
  background-color: #1A365D;
  color: #fff;
  padding: 60px 0 10px;
`;

const FooterWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 40px;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 20px;
    grid-template-columns: 1fr;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterLogo = styled(Link)`
  color: #fff;
  text-decoration: none;
  margin-bottom: 20px;
  display: inline-block;
  
  img {
    height: 60px;
  }
`;

const FooterTitle = styled.h3`
  font-size: 18px;
  margin-bottom: 20px;
  font-family: 'Playfair Display', serif;
  position: relative;
  padding-bottom: 10px;
  margin-top: 20px;
  
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 50px;
    height: 3px;
    background-color: #4CAF50;
  }
`;

const FooterLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  margin-bottom: 15px;
  font-size: 14px;
  font-family: 'Open Sans', sans-serif;
  transition: all 0.3s ease;
  display: block;
  
  &:hover {
    color: #4CAF50;
    padding-left: 5px;
  }
`;

const FooterText = styled.p`
  font-size: 14px;
  margin-bottom: 15px;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.5;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

const ContactIcon = styled.div`
  margin-right: 10px;
  color: #4CAF50;
`;

const SocialIcons = styled.div`
  display: flex;
  margin-top: 20px;
`;

const SocialLink = styled.a`
  color: #fff;
  font-size: 20px;
  margin-right: 15px;
  transition: all 0.3s ease;
  
  &:hover {
    color: #4CAF50;
    transform: translateY(-3px);
  }
`;

const FooterBottom = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 60px;
  text-align: center;
  
  @media screen and (max-width: 768px) {
    padding: 20px 20px 0;
  }
`;

const Copyright = styled.p`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-family: 'Open Sans', sans-serif;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterColumn>
          <FooterLogo to="/">
            <img src={logo} alt="Memorial Crematório Dom José" />
          </FooterLogo>
          <FooterText>
            Memorial Crematório e Cemitério Dom José, oferecendo serviços com respeito e profissionalismo para confortar nos momentos difíceis da vida.
          </FooterText>
          <SocialIcons>
            <SocialLink href="https://www.facebook.com/crematoriodomjosee" target="_blank" aria-label="Facebook">
              <FaFacebook />
            </SocialLink>
            <SocialLink href="https://www.instagram.com/crematoriodomjose/" target="_blank" aria-label="Instagram">
              <FaInstagram />
            </SocialLink>
          </SocialIcons>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle></FooterTitle>
          <FooterLink to="/cremacao">Cremação</FooterLink>
          <FooterLink to="/cemiterios">Cemitérios</FooterLink>
          <FooterLink to="/planos">Planos</FooterLink>
          <FooterLink to="/velorio-online">Velório Online</FooterLink>
        </FooterColumn>
        
        <FooterColumn>
          <FooterTitle></FooterTitle>
          <FooterLink to="/#funeraria">Funerária</FooterLink>
          <FooterLink to="/#about">Sobre Nós</FooterLink>
          <FooterLink to="/#contact">Contato</FooterLink>
          {/*<FooterLink to="/estrutura">Nossa Estrutura</FooterLink>
           <FooterLink to="/obituario">Obituário</FooterLink>*/}
        </FooterColumn>
        
        {/*<FooterColumn>
          <FooterTitle>Contato</FooterTitle>
          <ContactItem>
            <ContactIcon>
              <FaMapMarkerAlt />
            </ContactIcon>
            <FooterText>ERS 162, N 2191, Bairro Auxiliadora - Santa Rosa - RS</FooterText>
          </ContactItem>
          <ContactItem>
            <ContactIcon>
              <FaPhone />
            </ContactIcon>
            <FooterText>(55) 3512 2727</FooterText>
          </ContactItem>
          <ContactItem>
            <ContactIcon>
              <FaEnvelope />
            </ContactIcon>
            <FooterText>crematorio@crematoriodomjose.com.br</FooterText>
          </ContactItem>
        </FooterColumn>*/}
      </FooterWrapper>
      
      <FooterBottom>
        <Copyright>
          © Created by
          <a href="https://tweezer.com.br" target="_Blank" style={{fontSize: '14px', color: 'white'}}> Tweezer | Agência Digital</a>
        </Copyright>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
